import React from 'react';

import { DisplayText, DisplayTitle } from './CheckoutComponents';
import EmailInfo from './EmailInfo';


function PaymentMessage(props) {
  const {
    processing,
    anchorFirstName,
    isRenewal,
    productType,
    subNotActive,
  } = props;

  if (processing) {
    return (
      <div className="checkout-overlay">
        <div className="lds-dual-ring" />
        <div>Processing...</div>
      </div>
    );
  }

  if (subNotActive) {
    return (
      <h2>Your subscription will be activated momentarily</h2>
    );
  }

  return (
    <div className="card-content" id="success-message">
      <React.Fragment>
        <h2>
          <DisplayTitle
            anchorFirstName={anchorFirstName}
            productType={productType}
          />
        </h2>
        <p className="lead">
          <DisplayText
            isRenewal={isRenewal}
            productType={productType}
          />
        </p>
      </React.Fragment>
      <EmailInfo />
    </div>
  );
}

export default PaymentMessage;
